import moment from 'moment';

const CUSTOM_LOCALE = 'es-PR';

export const phone = (value) => {
  if (value == undefined || value == '') return '-';

  return value
    .replace(/[^0-9]/g, '')
    .replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
};

export const studentSie = (value) => {
  value = value || '';
  return `${value.replace(/[0-9]/gi, '')} - ${value.replace(
    /[a-z A-Z À-ú]/gi,
    ''
  )}`;
};

export const price = (value) => {
  let val = (value / 1).toFixed(2);
  let formattedValue = parseFloat(Math.abs(val)).toLocaleString('en-US', {
    minimumFractionDigits: 2,
  });

  return val < 0 ? '-$' + formattedValue : '$' + formattedValue;
};

export const currency = (value, includeSymbol = false) => {
  if (value == undefined || value == '') return '-';
  const result = value.toLocaleString('en-US', { minimumFractionDigits: 2 });
  return result && includeSymbol ? `$${result}` : result;
};

export const ssn = (value) => {
  if (value === undefined || value === '' || value === null) return '';

  const lastDigits = value.substr(-4);
  return `XXX-XX-${lastDigits}`;
};

export const capitalize = (value) => {
  if (!value) return '';
  value = value.toString();

  return value
    .toLowerCase()
    .split(' ')
    .map((w) => w.substring(0, 1).toUpperCase() + w.substring(1))
    .join(' ');
};

export const daywithnumber = (value) => {
  if (!value) return '';
  value = value.toString();

  return moment(value)
    .locale(CUSTOM_LOCALE)
    .format('DD - dddd')
    .replace(/ 0(?:0)?/, ' ')
    .split(' ')
    .map((w) => w.substring(0, 1).toUpperCase() + w.substring(1))
    .join(' ');
};

export const formatDateAsDay = (value) => {
  if (!value) return '';
  value = value.toString();

  return moment(value)
    .locale(CUSTOM_LOCALE)
    .format('DD');
};

export const date = (value) => {
  if (value == undefined || value == '') return '-';

  let result = moment(value)
    .locale(CUSTOM_LOCALE)
    .format('DD/MMM/YYYY')
    .replace(/ 0(?:0)?/, ' ');

  return result;
};

export const formatDateWithHour = (value) => {
  if (value) {
    let d = new Date(value);
    let datestring =
      ('0' + (d.getMonth() + 1)).slice(-2) +
      '/' +
      ('0' + d.getDate()).slice(-2) +
      '/' +
      d.getFullYear();
    let hours = d.getHours();
    let minutes = d.getMinutes();
    let ampm = hours >= 12 ? 'pm' : 'am';
    hours = hours % 12;
    hours = hours ? hours : 12;
    minutes = minutes < 10 ? '0' + minutes : minutes;
    let strTime = hours + ':' + minutes + ' ' + ampm;
    return datestring + ' ' + strTime;
  }
};

export const hourFilter = (value) => {
  if (value == undefined || value == '') return '-';

  let result = moment(value)
    .locale(CUSTOM_LOCALE)
    .format('hh:mm a');

  return result;
};

export const emptyFilter = (value) => {
  return !value || value?.toString().trim().length === 0 ? '-' : value;
};

export const boolText = (value) => {
  return value ? 'Si' : 'No';
};

export const upperCaseFilter = (value) => {
  return value.toString().toUpperCase();
};

export const dateTime = (value) => {
  if (value == undefined || value == '') return '-';

  let date = moment(value)
    .locale(CUSTOM_LOCALE)
    .format('DD/MMM/YYYY')
    .replace(/ 0(?:0)?/, ' ');

  let d = new Date(value);
  let hours = d.getHours();
  let minutes = d.getMinutes();
  let ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12;
  hours = hours ? hours : 12;
  minutes = minutes < 10 ? '0' + minutes : minutes;

  return `${date} ${`${hours}:${minutes} ${ampm}`}`;
};

export const formatNumber = (value) => {
  if (typeof value !== 'number') {
    value = parseFloat(value);
    if (isNaN(value)) return value; // Si no es un número válido, retornar el valor original.
  }
  return value.toLocaleString('en-US'); // Formatear con separadores de miles.
};

export const appointmentFormat = (value) => {
  if (value == undefined || value == '') return '-';

  return value.replace(/[^0-9]/g, '').replace(/(\d{4})(\d{6})/, '$1-$2');
};
